export default "__VITE_ASSET__CrbE67H9__"